module.exports = __webpack_public_path__ + "static/media/clickhere.940b1e22.png";